import { createModel } from '@rematch/core';

import { RootModel } from '../root';
import effects from './client.effects';
import { ClientState } from './client.model';
import reducers from './client.reducers';

const initialState: ClientState = {
  addresses: null,
  phones: null,
  emails: null
};

const clientModel = createModel<RootModel>()({
  state: initialState,
  reducers,
  effects
});

export default clientModel;
